import React from 'react';
import * as Styled from './styles';
import { Button, ButtonTypes, ModalWrapper } from '@common/components';
import Divider from '../Divider/Divider';

interface IProps {
  isOpen: boolean;
  recipientCount: number;
  deliveredCount: number;
  queuedCount: number;
  onViewRecipients?: () => void;
  onBackToSubmissions: () => void;
}

export const BroadcastCompleteModal = ({
  isOpen,
  recipientCount,
  deliveredCount,
  queuedCount,
  onViewRecipients,
  onBackToSubmissions,
}: IProps) => (
  <ModalWrapper isOpen={isOpen} contentStyles={{ borderRadius: 16, padding: 24 }}>
    <Styled.TitleIcon src={'/icons/success-check.svg'} />
    <Styled.Title>Broadcast sent successfully</Styled.Title>
    <Styled.MessageContent>
      <Styled.MainMessage>
        Your change broadcast was successfully sent to {recipientCount} email {recipientCount === 1 ? 'address' : 'addresses'}.
      </Styled.MainMessage>
      <Styled.BulletList>
        <Styled.BulletItem>{deliveredCount} {deliveredCount === 1 ? 'has' : 'have'} received the broadcast</Styled.BulletItem>
        {queuedCount > 0 && <Styled.BulletItem>{queuedCount} {queuedCount === 1 ? 'is' : 'are'} queued awaiting user opt-in</Styled.BulletItem>}
      </Styled.BulletList>
    </Styled.MessageContent>
    <Styled.Footer>
      <Button
        onClick={onViewRecipients}
        text="View recipients"
        type={ButtonTypes.PRIMARY_BORDER}
        data-testid="view-recipients-button"
      />
      <Divider type="vertical" size="50px" thickness={1} />
      <Button
        onClick={onBackToSubmissions}
        text="Back to submissions"
        type={ButtonTypes.SUCCESS}
        data-testid="back-to-submissions-button"
      />
    </Styled.Footer>
  </ModalWrapper>
);
